import Vue from "vue";
import DatePicker from "vue2-datepicker";
import SortedTablePlugin from "vue-sorted-table";
import Payments from "../widget-payment-create";
import Paginate from "@/components/widgets/pagination.vue";
import Customers from "@/components/widgets/customers";
import BillingNotes from "@/components/widgets/billing-notes";
import Loading from "@/components/widgets/Loading.vue";
import moment from 'moment'

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});
export default {
  components: {
    Customers,
    BillingNotes,
    DatePicker,
    Payments,
    Paginate,
    Loading,
  },
  data: function () {
    return {
      uploadedFiles: [],
      selectedRows: [],
      isCustomerPopupOpen: false,
      isBillingSelectorOpen: false,
      form: {
        document_no: "",
        document_date: "",
        remark: "",
        payment_type: null,
        amount: null,
      },
      loading: false,
      customer: {},
      busy: false,
      advanced: false,
      status: null,
      createId: null,
      openedCreate: false,
      sortDesc: false,
      totalItem: 0,
      apiStatus: "ไม่พบข้อมูล",
      doc: {
        start: null,
        end: null,
      },
      duedate: {
        start: null,
        end: null,
      },
      debtStatus: [
        { text: "On hold", value: "onhold" },
        { text: "ค้างชำระ", value: "overdue" },
        { text: "ยกเลิก", value: "cancel" },
        { text: "ชำระแล้ว", value: "success" },
      ],
      perPage: 6,
      sortBy: "name",
      currentPage: 1,
      currentData: {},
      keyword: "",
      fields: [
        {
          key: "document_no",
          label: "เลขที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "created_at",
          label: "วันที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "bill_customer_name",
          label: "ชื่อลูกหนี้",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "bill_seller",
          label: "ผู้รับผิดชอบ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "total_price",
          label: "ยอดชำระทั้งหมด",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
          class: "text-right",
        },
        {
          key: "remaining",
          label: "ยอดคงค้าง",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
          class: "text-right",
        },
        {
          key: "real_pay",
          label: "ชำระจริง",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          class: "text-right",
        },
      ],
      items: [],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    // this.onInitData()
  },
  methods: {
    parseMoney(value) {
      const normalized = String(value ?? "")
        .replace(/,/g, "")
        .trim();
      if (normalized === "") return 0;
      const amount = Number(normalized);
      return Number.isFinite(amount) ? amount : 0;
    },
    toCents(value) {
      return Math.round((this.parseMoney(value) + Number.EPSILON) * 100);
    },
    fromCents(cents) {
      // ปัดให้เหลือ 2 ตำแหน่งเสมอ กัน float artifact (เช่น 55.50000000001)
      return Math.round(cents) / 100;
    },
    getRemainingAmount(row) {
      const totalPriceCents = this.toCents(row?.total_price || 0);
      const totalPaidCents = this.toCents(row?.total_paid || 0);
      const remainingCents = totalPriceCents - totalPaidCents;
      // คงเครื่องหมายไว้ (บวก = ค้างชำระ, ลบ = ต้องคืนเงินลูกค้า)
      return this.fromCents(remainingCents);
    },
    // บิลยอดรวม 0 (เช่น CN หักหมด) — ตัดด้วยยอด 0 เพื่อปิดบิลได้
    isZeroBill(row) {
      return this.toCents(row?.total_price || 0) === 0;
    },
    parseRealPayAmount(row) {
      // เคสพิเศษ: บิลยอด 0 → อนุญาต real_pay = 0 (ปิดบิล)
      if (this.isZeroBill(row) && this.toCents(row?.real_pay || 0) === 0) {
        return { valid: true, amount: 0 };
      }

      const raw = String(row?.real_pay ?? "").trim();
      if (raw === "" || raw === "-") {
        return { valid: false, amount: 0 };
      }

      const amountCents = this.toCents(raw);
      const remainingCents = this.toCents(this.getRemainingAmount(row));

      // ยอดต้องไม่เป็น 0, เครื่องหมายต้องตรงกับยอดคงค้าง, และขนาดไม่เกินคงค้าง
      const sameSign = (amountCents > 0) === (remainingCents > 0);
      if (
        amountCents === 0 ||
        !sameSign ||
        Math.abs(amountCents) > Math.abs(remainingCents)
      ) {
        return { valid: false, amount: 0 };
      }

      return { valid: true, amount: this.fromCents(amountCents) };
    },
    getRealPayAmount(row) {
      const parsed = this.parseRealPayAmount(row);
      if (parsed.valid) {
        return parsed.amount;
      }
      return 0;
    },
    openBillingSelector() {
      this.isBillingSelectorOpen = true;
    },
    onBillingDocumentSelected(e) {
      this.isBillingSelectorOpen = false;
      if (e && e.status && e.data) {
        this.onBillingSelected(e.data);
      }
    },
    extractCustomerIdFromBilling(item) {
      return (
        item?.customer?.id ??
        item?.customer_detail?.id ??
        item?.customer_id ??
        item?.bill_customer_id ??
        item?.bill?.customer_id ??
        null
      );
    },
    normalizeCustomer(item, fallback = {}) {
      return {
        id: item?.id ?? fallback.id ?? null,
        customer_type: item?.customer_type ?? fallback.customer_type ?? "",
        code: item?.code ?? fallback.code ?? "",
        name: item?.name ?? fallback.name ?? "",
        phone_number: item?.phone_number ?? fallback.phone_number ?? "",
        company_name: item?.company_name ?? fallback.company_name ?? "",
        tax_id: item?.tax_id ?? fallback.tax_id ?? "",
        address: item?.address ?? fallback.address ?? "",
      };
    },
    async onBillingSelected(item) {
      const customerId = this.extractCustomerIdFromBilling(item);
      if (!customerId) {
        this.onExceptionHandler("ไม่พบข้อมูลลูกค้าในใบวางบิลที่เลือก");
        return;
      }

      const customer = this.normalizeCustomer(item?.customer, {
        id: customerId,
        customer_type: item?.customer?.customer_type ?? item?.customer_detail?.customer_type,
        code: item?.customer?.code ?? item?.customer_detail?.code,
        name: item?.customer?.name ?? item?.customer_detail?.name ?? item?.bill_customer_name,
        company_name: item?.customer?.company_name ?? item?.customer_detail?.company_name ?? item?.bill_customer_name,
        phone_number: item?.customer?.phone_number ?? item?.customer_detail?.phone_number,
        tax_id: item?.customer?.tax_id ?? item?.customer_detail?.tax_id,
        address: item?.customer?.address ?? item?.customer_detail?.address ?? item?.bill_customer_shipping_address,
      });
      this.customer = customer;
      this.isBillingSelectorOpen = false;

      await this.loadUnpaidBill(customerId, {
        selectedBillId: item?.id,
        selectedBillUuid: item?.uuid,
      });
    },
    autoSelectUnpaidRow(options = {}) {
      if (!Array.isArray(this.items) || this.items.length === 0) return;

      let targetIndex = -1;
      if (options.selectedBillId !== undefined && options.selectedBillId !== null) {
        targetIndex = this.items.findIndex(
          (row) => String(row?.id) === String(options.selectedBillId)
        );
      }

      if (targetIndex < 0 && options.selectedBillUuid) {
        targetIndex = this.items.findIndex(
          (row) => String(row?.uuid || "") === String(options.selectedBillUuid)
        );
      }

      if (targetIndex > -1 && this.$refs.unpaidTable) {
        if (typeof this.$refs.unpaidTable.clearSelected === "function") {
          this.$refs.unpaidTable.clearSelected();
        }
        if (typeof this.$refs.unpaidTable.selectRow === "function") {
          this.$refs.unpaidTable.selectRow(targetIndex);
        }
      }
    },
    updateTotalPaid() {
      // รวมยอดจากรายการที่ถูกเลือก และจำนวนที่กรอกจริงเท่านั้น
      const selectedIds = new Set(
        this.selectedRows.map((item) => String(item?.id))
      );
      const totalCents = this.items
        .filter((item) => selectedIds.has(String(item?.id)))
        .reduce((sum, item) => sum + this.toCents(this.getRealPayAmount(item)), 0);

      // เก็บเป็น string 2 ตำแหน่ง กันทศนิยมเกิน/ไม่ตรง
      this.form.amount = this.fromCents(totalCents).toFixed(2);
    },
    handleFileChange(event) {
      this.uploadedFiles = [];
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        this.uploadedFiles.push(files[i]);
      }
    },
    onCustomerSelected(e) {
      this.isCustomerPopupOpen = false;

      if (e.data) {
        this.customer = e.data;
        this.loadUnpaidBill(e.data.id);
      }
    },
    validateInput(e) {
      let value = e;

      // Allow only digits and one dot (.)
      value = value.replace(/[^0-9.]/g, ""); // Remove anything except numbers and dot

      // Ensure only one dot (.) is allowed
      if (value.indexOf(".") !== value.lastIndexOf(".")) {
        value = value.slice(0, value.lastIndexOf("."));
      }

      // Update the model value
      this.amount = value;
    },
    onRowSelected(items) {
      this.selectedRows = items;
      this.updateTotalPaid();
    },
    onInputTotalPaid(val, row) {
      let value = String(val ?? "");
      // เก็บเครื่องหมายลบนำหน้า (สำหรับบิลคืนเงิน) แล้วกรองอักขระอื่น
      const isNeg = value.trim().startsWith("-");
      value = value.replace(/[^0-9.]/g, "");
      if (value.indexOf(".") !== value.lastIndexOf(".")) {
        value = value.slice(0, value.lastIndexOf("."));
      }
      // จำกัดทศนิยมไม่เกิน 2 ตำแหน่ง (กันยอดรวมเพี้ยน)
      const dotIndex = value.indexOf(".");
      if (dotIndex !== -1) {
        value = value.slice(0, dotIndex + 1) + value.slice(dotIndex + 1).slice(0, 2);
      }
      if (isNeg && value !== "") {
        value = "-" + value;
      } else if (isNeg && value === "") {
        value = "-";
      }

      const inputCents = this.toCents(value);
      const remainingCents = this.toCents(this.getRemainingAmount(row));
      // clamp ด้วยขนาด (absolute) คงเครื่องหมายของยอดคงค้าง
      if (value !== "" && value !== "-" && Math.abs(inputCents) > Math.abs(remainingCents)) {
        row.real_pay = this.fromCents(remainingCents).toFixed(2);
      } else {
        row.real_pay = value;
      }
      this.updateTotalPaid();
    },
    async loadUnpaidBill(id, options = {}) {
      try {
        this.loading = true;
        this.busy = true;
        this.apiStatus = "กำลังค้นหาข้อมูล..";

        const result = await Vue.prototype.$axios.get(
          `${Vue.prototype.$host}/api/v1/unPaidBillingNotes/${id}`
        );

        this.loading = false;
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.selectedRows = [];
        this.form.amount = null;

        if (result) {
          this.currentData = result.data.data;
          this.items = (result.data.data || []).map((item) => ({
            ...item,
            real_pay: "",
          }));
          this.totalItem = this.items.length;
          this.$nextTick(() => this.autoSelectUnpaidRow(options));
        } else {
          this.items = [];
          this.totalItem = 0;
        }
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async requestPayment() {
      if (this.form.document_date === "") {
        this.onExceptionHandler("กรุณาเลือกวันที่ตัดชำระ");
        return false;
      }

      if (this.form.payment_type === null) {
        this.onExceptionHandler("กรุณาระบุประเภทการชำระ");
        return false;
      }
      
      this.updateTotalPaid();

      if (this.selectedRows.length === 0) {
        this.onExceptionHandler("กรุณาเลือกใบวางบิลที่ต้องการชำระ");
        return;
      }

      // ยอดรวม 0 ยอมรับได้เฉพาะกรณีทุกบิลที่เลือกเป็นบิลยอด 0 (ตัดปิดด้วยยอด 0)
      const selectedRowObjs = this.items.filter((item) =>
        this.selectedRows.some((sel) => String(sel?.id) === String(item?.id))
      );
      const allZeroBills = selectedRowObjs.length > 0 && selectedRowObjs.every((row) => this.isZeroBill(row));

      const amountCents = this.toCents(this.form.amount);
      if (amountCents === 0 && !allZeroBills) {
        this.onExceptionHandler("กรุณาระบุจำนวนชำระ");
        return;
      }

      if (this.uploadedFiles.length === 0) {
        this.onExceptionHandler("กรุณาเลือกไฟล์หลักฐานการชำระเงิน!");
        return false;
      }

      const selectedIds = new Set(
        this.selectedRows.map((item) => String(item?.id))
      );
      const selectedData = this.items
        .filter((item) => selectedIds.has(String(item?.id)))
        .map((row) => ({
        id: row.id,
        real_pay: this.getRealPayAmount(row),
        is_zero_bill: this.isZeroBill(row), // บิลยอด 0 อนุญาต real_pay=0
      }));

      // ยอดต้องไม่เป็น 0 (รองรับยอดติดลบ = คืนเงิน) — ยกเว้นบิลยอดรวม 0 (ตัดปิดด้วยยอด 0)
      if (selectedData.some((row) => !row.is_zero_bill && this.toCents(row.real_pay) === 0)) {
        this.onExceptionHandler("กรุณาระบุยอดชำระจริงให้ถูกต้อง (ไม่เป็น 0 และไม่เกินยอดคงค้าง)");
        return;
      }

      const totalAmountCents = selectedData.reduce(
        (sum, row) => sum + this.toCents(row.real_pay),
        0
      );
      // ส่งเป็น string 2 ตำแหน่ง ให้ตรงกับผลรวมของ items[].real_pay
      const totalAmount = this.fromCents(totalAmountCents).toFixed(2);

      // console.log(this.form.amount);
      // console.log(selectedData);
      // console.log(this.uploadedFiles);
      

      try {
        this.loading = true;
        this.busy = true;

        const formData = new FormData();
        formData.append("remark", this.form.remark ?? "");
        formData.append("amount", totalAmount);
        formData.append("customer_id", this.customer.id ?? "");
        formData.append("document_date", moment(this.form.document_date).format("YYYY-MM-DD"));
        formData.append('payment_type', this.form.payment_type)
        formData.append(
          "items",
          JSON.stringify(
            selectedData.map((row) => ({
              id: row.id,
              real_pay: row.real_pay.toFixed(2),
            }))
          )
        );

        // assigning a new image to formData
        for (let index = 0; index < this.uploadedFiles.length; index++) {
          const element = this.uploadedFiles[index];
          formData.append("images[]", element);
        }

        // const ids = this.selectedRows.map((item) => item.id);

        
        const result = await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/payment`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.loading = false;
        this.busy = false;

        if (result) {
          this.uploadedFiles = [];

          alert("ทำเรื่องชำระสำเร็จ");
          this.$router.go(this.$router.currentRoute);
        }
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "เกิดข้อผิดพลาด";
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
  },
};
